import styled from "styled-components";

const ProductImageContainer = styled.div`
    > .img-container-inner {
        min-height: 300px;
        &:not(.loaded) {
            background-color: #efefef;
        }
    }
`;

export default ProductImageContainer;
